export default __webpack_public_path__ + "static/media/card-bottom2.5c8c352e.webp";